"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResults = void 0;
const hooks_1 = require("../hooks");
const utility_1 = require("../utility");
/** This hook must never be used to render results */
const useResults = () => {
  const {
    results
  } = (0, hooks_1.useReactifySearchContext)();
  utility_1.debug.hook("useResults", "results", results.results);
  utility_1.debug.hook("useResults", "resultStats", results.resultStats);
  return {
    results: results.results,
    setResults: results.setResults,
    resultStats: results.resultStats,
    setResultStats: results.setResultStats
  };
};
exports.useResults = useResults;